import { Component, OnInit, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { Router, NavigationStart, ActivatedRoute, NavigationEnd } from "@angular/router";
import { Location } from '@angular/common';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ComponentName } from 'src/app/Enums/usersFilterEnums';
import { OfficesService } from '../../services/offices.service';
import { UsersService } from '../../services/users.service';
import { CitiesService } from '../../services/cities.service';
import { InwardService } from '../../services/inward.service';
import { AuditTrailService } from '../../services/audit-trail.service';
import { OutwardService } from '../../services/outward.service';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.less']
})
export class ConfirmationModalComponent implements OnInit {

  @Input()
  public buttonsTitle = {
    dismiss: 'Cancel',
    confirm: null,
    component: null
  };

  @Input() public description: string;
  @Input() public title: string;
  @Output() clikedonConfirm = new EventEmitter();
  constructor(private _router: Router, public modalRef: BsModalRef,
    private citiesService: CitiesService,
    private auditService: AuditTrailService,
    private _location: Location,
    private userService: UsersService,
    private officesService: OfficesService,
    private inwardService: InwardService,
    private outwardService: OutwardService
   ) {
  }
  ngOnInit() {
  }

  clikedonConfirmation(val) {

    if (val.target.textContent == "Reset") {
      if (this.buttonsTitle.component == ComponentName.Cities) {
        if (this.citiesService.resetFilters.observers.length > 0) {
          this.citiesService.resetFilters.next();
        }
        else{
          this.citiesService.resetHeaders.next();
        }
      }
      if (this.buttonsTitle.component == ComponentName.Offices) {
        if (this.officesService.resetFilters.observers.length > 0) {
          this.officesService.resetFilters.next();
        }
        else{
          this.officesService.resetHeaders.next();
        }
      }
      if (this.buttonsTitle.component == ComponentName.AuditConfiguration) {
        if (this.auditService.resetFilters.observers.length > 0) {
          this.auditService.resetFilters.next();
        }
        else{
          this.auditService.resetHeaders.next();
        }
      }
      if(this.buttonsTitle.component == ComponentName.Inward){
        if(this.inwardService.resetFilters.observers.length > 0){
          this.inwardService.resetFilters.next();
        }
        else{
          this.inwardService.resetHeaders.next();
        }
      }
      if(this.buttonsTitle.component == ComponentName.Outward){
        if(this.outwardService.resetFilters.observers.length > 0){
          this.outwardService.resetFilters.next();
        }
        else{
          this.outwardService.resetHeaders.next();
        }
      }
      if(this.buttonsTitle.component == ComponentName.OutwardL1Approver){
        if(this.outwardService.resetFilters.observers.length > 0){
          this.outwardService.resetFilters.next();
        }
        else{
          this.outwardService.resetHeaders.next();
        }
      }
      if(this.buttonsTitle.component == ComponentName.OutwardL2Approver){
        if(this.outwardService.resetFilters.observers.length > 0){
          this.outwardService.resetFilters.next();
        }
        else{
          this.outwardService.resetHeaders.next();
        }
      }
      if(this.buttonsTitle.component == ComponentName.OutwardSupervisor){
        if(this.outwardService.resetFilters.observers.length > 0){
          this.outwardService.resetFilters.next();
        }
        else{
          this.outwardService.resetHeaders.next();
        }
      }
      this.modalRef.hide();
      }
    else if (val.target.textContent == "Delete") {
      if (this.buttonsTitle.component == ComponentName.Cities) {
        this.citiesService.deleteCities.next();
      }
      else if (this.buttonsTitle.component == ComponentName.Users) {
        this.userService.deleteUser.next();
      }
      else if (this.buttonsTitle.component == ComponentName.Offices) {
        this.officesService.deleteOffices.next();
      }
      else if (this.buttonsTitle.component == ComponentName.Inward) {
        this.inwardService.deleteReg.next();
      }
      else if (this.buttonsTitle.component == 'Outward') {
        this.outwardService.deleteReg.next();
      }
      
      this.modalRef.hide();
    }
  }
}